import { SortableTable } from './SortableTable';
import type { EngineEvent } from '@avisoma/shared/dist/ProcessingData';
import { createStableRowKey } from '../lib/stableRowKey';

export function EngineEvents({ events }: { events: EngineEvent[] }) {
  if (!events.length) {
    return null;
  }

  const data = events.sort((a, b) => new Date(a.date ?? 0).getTime() - new Date(b.date ?? 0).getTime());

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-medium text-gray-900 dark:text-zinc-100">Engine Events ({events.length})</h2>
      <div className="overflow-hidden rounded-lg">
        <SortableTable
          storageId="engine-events"
          columns={[
            {
              accessor: 'index',
              label: 'Index',
              render: (_row, index) => index + 1,
            },
            {
              accessor: 'type',
              label: 'Type',
            },
            {
              accessor: 'date',
              label: 'Date',
            },
            {
              accessor: 'msn',
              label: 'MSN',
            },
            {
              accessor: 'thrust',
              label: 'Thrust',
            },
            {
              accessor: 'tsn',
              label: 'TSN',
            },
            {
              accessor: 'csn',
              label: 'CSN',
            },
            {
              accessor: 'reason',
              label: 'Reason',
            },
            {
              accessor: 'position',
              label: 'Position',
            },
            {
              accessor: 'operator',
              label: 'Operator',
            },
            {
              accessor: 'aircraftReg',
              label: 'Aircraft Reg',
            },
          ]}
          data={data}
          rowKey={createStableRowKey(data)}
        />
      </div>
    </div>
  );
}
